<div *ngIf="display">  
  <br />
  <div class="row" style="margin: auto">
    <div class="col">
      <div class="card">
        <div class="card-body" style="text-align: center; margin: auto;">
          <div class="card-title">All Users</div>
          <p class="card-text">
            List of Users:
            <thead>
              <tr>
                <th>ID&nbsp;</th><br />
                <th>Username</th><br />
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let user of allUsers">
                <td>{{user.id}}</td><br />
                <td>{{user.username}}</td><br />
              </tr>
            </tbody>
          </p>
        </div>
      </div>
    </div>
  </div>
  <br />

  <h3 style="text-align: center;">
    Please enter eToro username:
  </h3>

  <div class="row" style="text-align: center; margin: auto;">
    <div class="col">
      <input id="email" class="form-control" name="email" type="email" placeholder="Type your email.."
        (input)="username=$event.target.value">
    </div>
    <div class="col">
      <button type="submit" id="SendButton" name="submit" value="Submit" class="btn theme-btn hoverclr" (click)="submit()"
        style="margin-left: 20px">Submit</button>
    </div>
  </div>
  <br />

  

<div >

  <h1 style="text-align: center;">
    Welcome to {{ title }}!
  </h1>
  
  <ngb-tabset [destroyOnHide]="false">
  
    <ngb-tab title="Feed">
  
      <ng-template ngbTabContent>
  
        <div class="row" style="margin: auto">
          <div class="col">
            <div class="card">
              <div class="card-body" style="text-align: center; margin: auto;">
                <div class="card-title"></div>
                <div class="card-text" style="margin:auto;">
                  <iframe width="900" height="1600" src="https://rss.app/embed/v1/wall/VKQizmR7fT4Q9q9B" frameborder="0"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
  
    </ngb-tab>
  
    <ngb-tab>
  
      <ng-template ngbTabTitle>Stats</ng-template>
  
      <ng-template ngbTabContent>
  
        <div class="row" style="text-align: center; margin: auto;">
          <div class="col">
            <div class="card">
              <div class="card-body" style="margin: auto">
                <div class="card-title">Quarterly statistics!</div>
                <p class="card-text" class="table table-striped">
                  Our trading statistics for this quarter!
                  <thead>
                    <tr>
                      <th>WeeklyDD</th>
                      <th>Peak to Valley</th>
                      <th>Profitable Weeks %</th>
                      <th>Profitable Months %</th>
                      <th>Avg Position Size</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{discoveryweeklyDD}}</td>
                      <td>{{discoverypeakToValley}}</td>
                      <td>{{discoveryprofitableWeeksPct}}</td>
                      <td>{{discoveryprofitableMonthsPct}}</td>
                      <td>{{discoveryavgPosSize}}</td>
                    </tr>
                  </tbody>
                  <thead>
                    <th>Weeks Trading</th>
                    <th>Gain</th>
                    <th>Daily Gain</th>
                    <th>Weekly Gain</th>
                    <th>Risk Score</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{discoveryweeksSinceRegistration}}</td>
                      <td>{{discoverygain}}</td>
                      <td>{{discoverydailyGain}}</td>
                      <td>{{discoverythisWeekGain}}</td>
                      <td>{{discoveryriskScore}}</td>
                    </tr>
                  </tbody>
                  <thead>
                    <th>Copiers</th>
                    <th>Copiers Gain</th>
                    <th>Trades #</th>
                    <th>Win Ratio</th>
                    <th>Discovery Daily</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{discoverycopiers}}</td>
                      <td>{{discoverycopiersGain}}</td>
                      <td>{{discoverytrades}}</td>
                      <td>{{discoverywinRatio}}</td>
                      <td>{{discoverydailyDD}}</td>
                    </tr>
                  </tbody>
                </p>
              </div>
            </div>
          </div>
        </div><br />
        
        <div class="row" style="text-align: center; margin: auto;">
          <div class="col">
            <div class="card">
              <div class="card-body" style="text-align: center; margin: auto;">
                <div class="card-title">Risk Score!</div>
                <p class="card-text"  class="table table-striped">
                  Check our Risk Score breakdown!
                  <thead>
                    <tr>
                      <th>ID</th><br />
                      <th>Risk Contribution %</th><br />
                      <th>Investment %</th><br />
                      <th>Exposure %</th><br />
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let instrument of instrumentIds">
                      <td>{{instrument.instrumentId}}</td><br />
                      <td>{{instrument.riskContributionPct}}</td><br />
                      <td>{{instrument.investmentPct}}</td><br />
                      <td>{{instrument.exposurePct}}</td><br />
                    </tr>
                  </tbody>
                </p>
              </div>
            </div>
          </div><!--
          <div class="col">
            <div class="card">
              <div class="card-body" style="margin: auto;">
                <div class="card-title">Companies</div>
                <p class="card-text">
                  These are some of the companies we have positions in
                  <thead id="positions">
                    <tr>
                      <th>Positions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let name of nameVals">
                      <td>{{name}}</td>
                    </tr>
                  </tbody>
                </p>
              </div>
            </div>
          </div>-->
        </div>
        <br />
        
        <div class="row" style="margin: auto">
          <div class="col">
            <div class="card">
              <div class="card-body" style="text-align: center; margin: auto;">
                <div class="card-title"></div>
                <div class="card-text" style="margin:auto;">
                  <div id="containerPerf" style="text-align: center;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        
        <div class="row" style="margin: auto">
          <div class="col">
            <div class="card">
              <div class="card-body" style="text-align: center; margin: auto;">
                <div class="card-title"></div>
                <div class="card-text" style="margin:auto;">
                  <div id="containerRisk" style="text-align: center;"></div>
                </div>
              </div>
              Average Risk Score: {{riskAvg}}
            </div>
          </div>
          <div class="col">
            <div class="card">
              <div class="card-body" style="text-align: center; margin: auto;">
                <div class="card-title">We currently have <b>{{recentCopiers}}</b> traders copy trading us!</div>
                <div class="card-text" style="margin:auto;">
                  <div id="copiersContainer" style="text-align: center;"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br/>
  
      </ng-template>
  
    </ngb-tab>
  
    <ngb-tab>
  
      <ng-template ngbTabTitle>Portfolio</ng-template>
  
      <ng-template ngbTabContent>
  
        <div class="row" style="margin: auto">
          <div class="col">
            <div class="card">
              <div class="card-body" style="text-align: center; margin: auto;">
                <div class="card-title">Live Portfolio</div>
                <p class="card-text"  class="table table-striped">
                  This is our live portfolio, and will update frequently.
                  <thead>
                    <tr>
                      <th>ID</th><br />
                      <th>Investment %</th><br />
                      <th>Net Profit</th><br />
                      <th>Open Rate</th><br />
                      <th>Timestamp</th><br />
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let position of portfolioPositions">
                      <td>{{position.positionId}}</td><br />
                      <td>{{position.investmentPct}}</td><br />
                      <td>{{position.netProfit}}</td><br />
                      <td>{{position.openRate}}</td><br />
                      <td>{{position.openTimestamp}}</td><br />
                    </tr>
                  </tbody>
                </p>
              </div>
            </div>
          </div>
        </div>
        <br />
  
      </ng-template>
  
    </ngb-tab>
  
    <ngb-tab title="Chart">
  
      <ng-template ngbTabContent>
        <section class="section" id="about">
          <div class="shell shell--size-3">
            <div class="section__head">
              <h6>Algorithm</h6>
    
              <h2>Last Month’s Performance</h2>
            </div><!-- /.section__head -->
    
            <div class="chart">
              <div class="chart__head hidden-xs">
                <div class="chart__head-content">
                  <h6>eToro Analysis</h6>
    
                  <h5>Cosmic Algorithm Ltd.</h5>
    
                  <span>Dynamically Updated</span>
                </div><!-- /.chart__head-content -->
    
                
              </div><!-- /.chart__head -->
    
              <div class="chart__body" class="wow fadeInRight" data-wow-delay=".5s">
                <div id="container" style="text-align:center">
                </div>
              </div><!-- /.chart__body -->
            </div><!-- /.chart -->
          </div><!-- /.shell -->
        </section><!-- /.section -->
  
        <div id="container" style="text-align:center">
        </div>
  
      </ng-template>
  
    </ngb-tab>
  
  </ngb-tabset>
  
  </div>

